/// <reference path="../services/session.service.ts" />
/// <reference path="../services/pipelinedata.service.ts" />
/// <reference path="../services/navigation.service.ts" />

module App.Controllers {
    'use strict'

    export interface IMenuController {

    }

    export class MenuController implements IMenuController {
        static controllerId: string = "menuController";

        static $inject = [
            '$rootScope',
            '$q',
            '$scope',
            '$timeout',
            '$state',
            Services.NavigationService.serviceId,
            Services.SessionService.serviceId,
            Services.PipelineDataService.serviceId
        ];

        steps: Interfaces.ICustomState[] = [];
        currentState: Interfaces.ICustomState
        lastStateIndex: number[] = [0];

        constructor(public $rootScope: Interfaces.IAppRootScope,
            public $q: ng.IQService,
            public $scope: ng.IScope,
            public $timeout: ng.ITimeoutService,
            private $state: ng.ui.IStateService,
            public navigationService: Interfaces.INavigationService,
            public sessionService: Interfaces.ISessionService,
            public pipelineDataService: Services.IPipelineDataService,
        ) {
            this.loadSteps()
            var self = this

            $rootScope.$on('$locationChangeStart', (event, next, current) => {
                self.currentState = self.navigationService.currentStep()

                var currentIndex = this.currentStateIndex()
                if (currentIndex != self.lastStateIndex[0] && currentIndex < 6)
                    self.lastStateIndex.unshift(currentIndex)

                if (self.lastStateIndex.length > 5)
                    self.lastStateIndex.splice(5, 100)
            })

            this.currentState = this.navigationService.currentStep()
        }

        getPreviousIndex = () => {
            return this.lastStateIndex[1]
        }

        currentStateIndex = () => {
            if (this.steps.length > 0) {
                for (var i = 0; i < this.steps.length; i++) {
                    if (this.steps[i].name == this.currentState.name)
                        return i
                }
            }

            return 6
        }

        getCurrentStepNumber = () => {
            if (this.steps.length > 0) {
                for (var i = 0; i < this.steps.length; i++) {
                    if (this.steps[i].name == this.currentState.name)
                        return i + 1
                }
            }

            return ''
        }

        goBackToStep() {
            if (this.currentStateIndex() > 0) {
                this.goToStep(this.steps[this.currentStateIndex() - 1], this.currentStateIndex() - 1)
            }
        }

        loadSteps = () => {
            this.pipelineDataService.getPipelineSteps().then((items) => {
                this.getMenuNames(items)
            }).catch((err) => {
                console.log('error loading menu: ' + JSON.stringify(err))
            })
        }

        getMenuNames(items: string[]) {
            for (var item in items) {
                var state = this.navigationService.getStepByStepName(items[item])
                if (state != null && state.showInMenu && (this.steps.filter((x) => x.name == state.name).length == 0)) {
                    this.steps.push(state)
                }
            }
        }

        goToStep(step, index) {
            //Prevent skipping to last step
            //Can only go to next step if the step is 1 higher than the current step or lower than the current step
            var isAllowedToGoToStep = this.currentStateIndex() + 1 == index || this.currentStateIndex() > index
            if (this.isStepEnabled(step) && isAllowedToGoToStep) {
                this.$state.go(step.name, { location: 'replace', reload: true, notify: false })
            }
        }

        isStepEnabled(step: Interfaces.ICustomState) {
            if (step != null)
                return step.order <= this.sessionService.maxStepNumber

            return false
        }
    }

    app.controller(MenuController.controllerId, MenuController)
}
